.row {
  display: flex;
  align-items: center;
  gap: var(--zumpo-space-12);
  min-height: 52px;
  padding: var(--zumpo-space-6) var(--zumpo-space-8);
  border-radius: var(--zumpo-radius-12);
  color: var(--zumpo-ink);
}

.highlight {
  background: var(--zumpo-sand);
}

.details {
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: var(--zumpo-space-2);
  min-width: 0;
}

.nameLine,
.statusLine {
  display: flex;
  align-items: center;
  min-width: 0;
}

.nameLine {
  gap: var(--zumpo-space-6);
}

.statusLine {
  gap: var(--zumpo-space-4);
  color: var(--zumpo-muted);
}

.name {
  overflow: hidden;
  font: var(--zumpo-text-label);
  letter-spacing: var(--zumpo-text-label-tracking);
  text-overflow: ellipsis;
  white-space: nowrap;
}

.host {
  flex: none;
}

/* A long status, like a phone ranking's place and codes cracked, ends in an
   ellipsis instead of running under the score. */
.status {
  overflow: hidden;
  font: var(--zumpo-text-small);
  letter-spacing: var(--zumpo-text-small-tracking);
  text-overflow: ellipsis;
  white-space: nowrap;
}

.wrap .status {
  white-space: normal;
}

.statusIcon {
  flex: none;
}

.score {
  flex: none;
  font: var(--zumpo-text-number);
  letter-spacing: var(--zumpo-text-number-tracking);
  text-align: right;
}

.scored .status {
  color: var(--zumpo-green);
}

.scored .statusIcon {
  color: var(--zumpo-ink);
}

.away .avatar {
  opacity: 0.45;
}

.away .name,
.away .score {
  color: var(--zumpo-muted);
}
